t = require('views/internal/teacup-with-helpers')('attachment_thumb')
colors = require 'data/colors.json'

module.exports = t.renderable ({
  canReply,
  canUseViewer,
  date,
  edgeColor,
  editable,
  ext,
  imgSrc,
  isCover,
  isHidden,
  name,
  openIconClass,
  openText,
  plugin,
  pluginEnablementInProgress,
  previewClass,
  removeText,
  url: href,
  upsellEnabled
}) ->
  thumbnailPreviewClasses =
    'attachment-thumbnail-preview': true
    'js-open-viewer': canUseViewer
    'attachment-thumbnail-preview-is-cover': isCover

  if isHidden
    return t.div

  styles = {}
  if imgSrc
    styles['background-image'] = t.urlify(imgSrc)
  if edgeColor
    styles['background-color'] = edgeColor

  t.a { href, class: t.classify(thumbnailPreviewClasses), target: '_blank', title: name, style: t.stylify(styles), rel: 'noreferrer nofollow' }, ->
    if previewClass
        t.span { class: ['attachment-thumbnail-preview-service-logo', previewClass].join(' ') }
    else
      if !imgSrc
        if ext
          t.span '.attachment-thumbnail-preview-ext', ->
            t.text ext
        else
          t.span '.icon-lg.icon-attachment.attachment-thumbnail-preview-attachment-icon'

  titleOptions = ->
    if date
      t.span ->
        t.format 'added', { date }

    if canReply
      t.span ->
        t.a '.attachment-thumbnail-details-title-options-item.js-reply', { href: '#' }, ->
          t.span '.attachment-thumbnail-details-options-item-text', ->
            t.format 'comment'

    if editable
      t.span ->
        t.a '.attachment-thumbnail-details-title-options-item.dark-hover.js-confirm-delete', { href: '#' }, ->
          t.span '.attachment-thumbnail-details-options-item-text', ->
            t.text removeText

      t.span ->
        t.a '.attachment-thumbnail-details-title-options-item.dark-hover.js-edit', { href: '#' }, ->
          t.span '.attachment-thumbnail-details-options-item-text', ->
            t.format 'edit'

  t.p '.attachment-thumbnail-details', {
    class: t.classify(
      'js-open-viewer': canUseViewer
      'js-open-in-new-window': !canUseViewer
    )
  }, ->
    t.span '.attachment-thumbnail-name', ->
      t.text name

    t.a '.attachment-thumbnail-details-title-action.dark-hover.js-attachment-action.js-direct-link', { href, target: '_blank', rel: 'noreferrer nofollow' }, ->
      t.icon openIconClass

    t.span '.u-block.quiet.attachment-thumbnail-details-title-options', -> titleOptions()

    if plugin && upsellEnabled
      t.span '.quiet.attachment-thumbnail-details-powerup', ->
        t.a '.attachment-thumbnail-details-powerup-item-button.js-enable-power-up', { href: '#', "data-plugin": plugin.name }, ->
          if plugin.icon
            t.span '.icon-sm.plugin-icon',
              style: t.stylify
                'background-image': t.urlify "#{ plugin.icon }?color=#{ colors.iconDefault }"
          else
            t.span '.icon-sm.icon-power-up'
          t.format 'enable-power-up', { powerUpName: plugin.name }

        t.a '.attachment-thumbnail-details-powerup-item.js-show-power-up-suggestions-info', { href: '#', "data-plugin": plugin.name }, ->
          t.icon 'information', { class: 'power-up-item-suggestions-info-icon' }

    if pluginEnablementInProgress
      t.span '.quiet.attachment-thumbnail-details-powerup', ->
        t.a '.attachment-thumbnail-details-powerup-item-button.power-up-enablement-in-progress', { href: '#' }, ->
          t.span '.icon-sm.icon-power-up', ->
          t.format 'enabling-power-up'

    t.span '.quiet.attachment-thumbnail-details-options', ->
      if editable
        t.a '.attachment-thumbnail-details-options-item.dark-hover.hide.js-make-cover', { href: '#' }, ->
          t.icon 'card-cover'
          t.text ' '
          t.span '.attachment-thumbnail-details-options-item-text', ->
            t.format 'make-cover'

        t.a '.attachment-thumbnail-details-options-item.dark-hover.hide.js-remove-cover', { href: '#' }, ->
          t.icon 'card-cover'
          t.text ' '
          t.span '.attachment-thumbnail-details-options-item-text', ->
            t.format 'remove-cover'

      return
    return
  return



// WEBPACK FOOTER //
// ./app/scripts/views/templates/attachment_thumb.coffee